import { render, staticRenderFns } from "./Pause.vue?vue&type=template&id=60058864&scoped=true&"
import script from "./Pause.vue?vue&type=script&lang=js&"
export * from "./Pause.vue?vue&type=script&lang=js&"
import style0 from "./Pause.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Pause.vue?vue&type=style&index=1&id=60058864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60058864",
  null
  
)

export default component.exports